import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validateNumber,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

/**
 * The QIDS score is a way of determining a patient’s level of depression before, during, and after treatment.
 * It's a 16-item measure of depressive symptom severity in patients.
 */
export default class QidsDeclaredJournalEvent extends JournalEvent {
  static override type = "qids-declared-journal-event";

  /**
   * An array containing a score corresponding to a numeroted question
   */
  @attr({
    defaultValue() {
      return [];
    }
  })
  declare items: number[];

  /**
   * The total score.
   * The total must always be set.
   * It can be set directly, without setting the other scores.
   * This may happen if the medic passes the scale outside the Platform
   * but still wants to track the final score.
   */
  @attr("number") declare total: number;

  static override validations(intl: IntlService) {
    return {
      total: [
        validatePresence({
          presence: true,
          description: intl.t("validations.qids-declared-journal-event.total")
        }),
        validateNumber({
          integer: true,
          description: intl.t("validations.qids-declared-journal-event.total")
        })
      ],
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.qids-declared-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----

  @belongsTo("patient", {
    async: false,
    inverse: "qidsDeclaredJournalEvents"
  })
  declare patient: Patient;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "qids-declared-journal-event": QidsDeclaredJournalEvent;
  }
}
